import React, { useState, useEffect, useRef } from 'react';

function CariKendaraan2({ onSelect, onCancel, jns_kendaraan = 'SEMUA' }) {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const schema = localStorage.getItem('schema');
  const inputRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) inputRef.current.focus();  

    const fetchData = async () => {
      try {
        const param = jns_kendaraan ? `&jns_kendaraan=${jns_kendaraan}` : 'SEMUA';
        const url = `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=mobil${param}&schema=${schema}`;
        const response = await fetch(url);
        const result = await response.json();
        const arr = Array.isArray(result) ? result : [];
        setData(arr);
        setFilteredData(arr);
      } catch (error) {
        console.error('Gagal mengambil data:', error);
      }
    };

    fetchData();
  }, [jns_kendaraan, schema]);

  useEffect(() => {
    const filtered = data.filter(
      (item) =>
        (item.KD_KENDARAAN || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.NOPOL || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.SOPIR || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
        (item.JNS_KENDARAAN || '').toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredData(filtered);
  }, [searchTerm, data]);

  const toggleSelect = (item) => {
    const exists = selectedItems.find((k) => k.KD_KENDARAAN === item.KD_KENDARAAN);
    if (exists) {
      setSelectedItems(selectedItems.filter((k) => k.KD_KENDARAAN !== item.KD_KENDARAAN));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };

  const isSelected = (kd) => selectedItems.some((i) => i.KD_KENDARAAN === kd);

  const isMobile = window.innerWidth <= 480;

  return (
    <div
      style={{
        width: isMobile ? '92%' : '700px',
        margin: 'auto',
        padding: isMobile ? 15 : 20,
        backgroundColor: '#ffffff',
        borderRadius: 10,
        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      }}
    >
      <h2
        style={{
          textAlign: 'center',
          fontSize: isMobile ? 18 : 22,
          color: '#333',
          marginBottom: 15,
        }}
      >
        Pilih Kendaraan
      </h2>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          marginBottom: 12,
          flexWrap: 'wrap',
          gap: 8,
        }}
      >
        <button
          onClick={onCancel}
          style={{
            flex: isMobile ? 1 : 'none',
            padding: isMobile ? '8px 12px' : '10px 20px',
            backgroundColor: '#f44336',
            color: 'white',
            border: 'none',
            borderRadius: 6,
            cursor: 'pointer',
            fontSize: isMobile ? 13 : 14,
          }}
        >
          Batal
        </button>

        <button
          onClick={() => onSelect(selectedItems)}
          disabled={selectedItems.length === 0}
          style={{
            flex: isMobile ? 1 : 'none',
            padding: isMobile ? '8px 12px' : '10px 20px',
            backgroundColor: selectedItems.length > 0 ? '#4CAF50' : '#A5D6A7',
            color: 'white',
            border: 'none',
            borderRadius: 6,
            cursor: selectedItems.length > 0 ? 'pointer' : 'not-allowed',
            fontSize: isMobile ? 13 : 14,
          }}
        >
          Simpan
        </button>
      </div>

      <input
        ref={inputRef}
        type="text"
        placeholder="Cari kendaraan (kode, nopol, sopir)..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{
          width: '100%',
          padding: isMobile ? 6 : 8,
          marginBottom: 10,
          borderRadius: 6,
          border: '1px solid #ccc',
          fontSize: isMobile ? 13 : 14,
        }}
      />

      {!isMobile && (
        <div style={{ maxHeight: 400, overflowY: 'auto' }}>
          <table
            style={{
              width: '100%',
              borderCollapse: 'collapse',
              fontSize: 14,
            }}
          >
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0' }}>
                <th style={{ padding: 8, border: '1px solid #ccc' }}></th>
                <th style={{ padding: 8, border: '1px solid #ccc' }}>Kode</th>
                <th style={{ padding: 8, border: '1px solid #ccc' }}>Nopol</th>
                <th style={{ padding: 8, border: '1px solid #ccc' }}>Sopir</th>
                <th style={{ padding: 8, border: '1px solid #ccc' }}>Jenis</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.map((item, idx) => (
                <tr
                  key={idx}
                  style={{
                    backgroundColor: isSelected(item.KD_KENDARAAN) ? '#E8F5E9' : 'white',
                    transition: '0.2s',
                  }}
                  onClick={() => toggleSelect(item)}
                >
                  <td style={{ textAlign: 'center', border: '1px solid #ccc' }}>
                    <input
                      type="checkbox"
                      checked={isSelected(item.KD_KENDARAAN)}
                      readOnly
                    />
                  </td>
                  <td style={{ padding: 6, border: '1px solid #ccc' }}>{item.KD_KENDARAAN}</td>
                  <td style={{ padding: 6, border: '1px solid #ccc' }}>{item.NOPOL}</td>
                  <td style={{ padding: 6, border: '1px solid #ccc' }}>{item.SOPIR}</td>
                  <td style={{ padding: 6, border: '1px solid #ccc' }}>{item.JNS_KENDARAAN}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {isMobile && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            maxHeight: 400,
            overflowY: 'auto',
            paddingBottom: 10,
          }}
        >
          {filteredData.map((item, idx) => (
            <div
              key={idx}
              onClick={() => toggleSelect(item)}
              style={{
                borderRadius: 8,
                backgroundColor: isSelected(item.KD_KENDARAAN)
                  ? '#E8F5E9'
                  : '#FAFAFA',
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                padding: 10,
                display: 'flex',
                flexDirection: 'column',
                gap: 4,
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong>{item.NOPOL}</strong>
                <input
                  type="checkbox"
                  checked={isSelected(item.KD_KENDARAAN)}
                  readOnly
                />
              </div>
              <div style={{ fontSize: 13, color: '#333' }}>
                <div>Kode: {item.KD_KENDARAAN}</div>
                <div>Sopir: {item.SOPIR}</div>
                <div>Jenis: {item.JNS_KENDARAAN}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CariKendaraan2;
